module.exports = __webpack_public_path__ + "img/ethswarm.3560eb1e.svg";